import React from "react";
import api from "../../../services/api";

export default function SheetCard({ sheet }) {
  return (
    <div className="border rounded p-3 mb-3">
      <div className="d-flex justify-content-between mb-2">
        <div>
          <h6 className="mb-1">{sheet.name}</h6>
          <SheetInfo sheet={sheet} />
        </div>
        {sheet.isNew && (
          <span className="badge bg-success align-self-start">Новый</span>
        )}
      </div>
      
      <SheetPreview sheet={sheet} />
      
      {sheet.errorMessage && (
        <div className="alert alert-danger mt-2 mb-0">
          {sheet.errorMessage}
        </div>
      )}
    </div>
  );
}

function SheetInfo({ sheet }) {
  return (
    <>
      <div className="text-muted small">
        ID: {sheet.id} | Создан: {new Date(sheet.creationTime).toLocaleString()}
      </div>
      <div className="text-muted small">
        Автор: {sheet.createdBy} | Статус: {sheet.status || "Не указан"}
      </div>
    </>
  );
}

function SheetPreview({ sheet }) {
  return (
    <div className="text-center bg-light p-2">
      <img
        src={api.getLayoutingSheetPreview(sheet.jobId)}
        style={{
          maxWidth: "100%",
          height: "400px",
          objectFit: "contain",
        }}
        alt={`Preview ${sheet.name}`}
      />
    </div>
  );
}